import React from 'react'
import { Modal } from 'react-bootstrap'
import ChangeStatusFormComponent from './ChangeStatusFormComponent'

interface ChangeStatusDialogProps {
    show: boolean,
    onClose: () => void,
    reservationId: string
}

const ChangeStatusDialog: React.FC<ChangeStatusDialogProps> = ({ show, onClose, reservationId }) => {
    return (
        <Modal show={show} onHide={onClose} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Change Status</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ChangeStatusFormComponent reservationId={reservationId} onClose={onClose} />
            </Modal.Body>
        </Modal>
    )
}

export default ChangeStatusDialog